const rootUrl = 'https://www.istaging.com/sdk/'

export const frontArrowImage = `${rootUrl}front-arrow.png`
export const gyroMessageMinJs = `${rootUrl}gyro-message.min.js`
export const gyro2MinJs = `${rootUrl}gyro2.min.js`
export const leftArrowImage = `${rootUrl}left-arrow.png`
export const leftFrontArrowImage = `${rootUrl}left-front-arrow.png`
export const linkImage = `${rootUrl}link.png`
export const logoTripodImage = `${rootUrl}logo-tripod.png`
export const memoImage = `${rootUrl}memo.png`
export const menuImage = `${rootUrl}menu.png`
export const nextPanoramaImage = `${rootUrl}next-panorama.png`
export const pointImage = `${rootUrl}point.png`
export const prevPanoramaImage = `${rootUrl}prev-panorama.png`
export const rightArrowImage = `${rootUrl}right-arrow.png`
export const rightFrontArrowImage = `${rootUrl}right-front-arrow.png`
export const tagImage = `${rootUrl}tag.png`
export const threeKrpanopluginMinJs = `${rootUrl}three.krpanoplugin.min.js`
export const videoImage = `${rootUrl}video.png`
export const webvrMinJs = `${rootUrl}webvr.min.js`
export const webvrCursorImage = `${rootUrl}webvr_cursor_80x80_17f.png`
